import { themeUi } from '../../themeUi/themeUi';

const totalPriceFooter = {
  borderTop: `1px solid ${themeUi.semantic.color.border.neutral600}`
};

export default totalPriceFooter;
